import * as Device from 'expo-device';
import * as ScreenOrientation from 'expo-screen-orientation';

export async function isTablet() {
  const deviceType = await Device.getDeviceTypeAsync();
  return deviceType === Device.DeviceType.TABLET;
}

export async function disableOrientationLock() {
  await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.DEFAULT);
}

export async function enablePortraitOrientationLock() {
  await ScreenOrientation.lockAsync(
    ScreenOrientation.OrientationLock.PORTRAIT_UP
  );
}

export async function enableLandscapeOrientationLock() {
  await ScreenOrientation.lockAsync(
    ScreenOrientation.OrientationLock.LANDSCAPE
  );
}
